import { FC, useEffect } from "react";
import { I_formNode, useForm } from "./../../../components/aio/aio-input";
import { I_model } from "../types";
import { useFreelancerProvider, useRootFreelancerProvider } from "../context";
import Icon from "@mdi/react";
import { mdiCalendar, mdiInformationOutline } from "@mdi/js";
import { useLocation } from "react-router-dom";

export const UserInfoForm: FC<{
    data: I_model,
    onChange: (v: I_model) => void,
    setDisabled: (v: boolean) => void,
    mode: 'add' | 'edit'
}> = (props) => {
    const { options, cities } = useRootFreelancerProvider()
    const { typeOptions,inputCls } = useFreelancerProvider()
    const hubOptions = options.hubs.map((o: any) => ({ text: o.name, value: o.id }))
    const form = useForm<I_model>({
        data: props.data, fa: true, showErrors: false,
        onChange: (data) => {
            console.log(data)
            props.onChange(data)
        },
        option: {
            required: ({ input }) => {
                if(input.field === "email"){return false}
                if(input.field === "recommenderCode"){return false}
                if(input.field === "isSuperAdmin"){return false}
                if(input.field === "isActive"){return false}
                if(input.field === "hasInsurance"){return false}
                return true
            },
            labelType: () => "online",
            className:()=>inputCls,

        },
        inputs: {
            type: { 
                label: 'نوع پرسنل', field: "type.id", type: 'select', 
                //disabled: props.mode === 'edit', 
                options: typeOptions 
            },
            name: { label: 'نام و نام خانوادگی', field: 'name', type: 'text' },
            nationalCode: { label: 'کد ملی', field: 'nationalCode', type: 'text', validation: ["irNationalCode"] },
            mobile: { label: 'شماره موبایل', field: 'mobile', type: 'text', validation: ["irMobile"], filter: ['number'] },
            fatherName: { label: 'نام پدر', field: 'fatherName', type: 'text' },
            email: { label: 'پست الکترونیکی', field: 'email', type: 'text', validation: ['email'] },
            birthDate: {
                label: 'تاریخ تولد', field: 'birthDate', type: 'date', jalali: true, size: 16,
                option: {
                    close: () => true
                },
                after: <Icon path={mdiCalendar} size={0.8} color='#555' />, caret: false, placeholder: ' '
            },
            gender: {
                label: 'جنسیت', field: 'gender.id' as any, type: 'select',
                options: options.sexTypes.map((o: any) => ({ text: o.value, value: o.key })),
                popover: { fitHorizontal: true }
            },
            phone: { label: 'شماره تلفن ثابت', field: 'phone', type: 'text', filter: ['number'] },
            essentialPhone: { label: 'شماره ضروری', field: 'essentialPhone', type: 'text', filter: ['number'] },
            residentCity: {
                label: 'شهر', field: 'residentCity.id', type: 'select', search: 'جستجو', popover: { fitHorizontal: true },
                options: cities,
                option: {
                    text: (o) => o.text.split(' - ')[1],
                    value: (o) => o.id,
                    before: (o) => <div style={{ whiteSpace: 'nowrap' }}>{`${o.text.split(' - ')[0]} - `}</div>
                }

            },
            hubId: {
                label: 'هاب', field: "hubId" as any, search: 'جستجو', type: 'select', options: hubOptions,
                popover: { fitHorizontal: true }
            },
            residentAddress: { label: 'آدرس محل سکونت', field: 'residentAddress', type: 'text' },
            recommenderCode: { label: 'کد معرف', field: 'recommenderCode', type: 'text' },
            isActive: { field: 'isActive', label: '', attrs:{style:{width:'100%',border:'none'}}, type: 'checkbox', text: 'فعال', switchOptions: { size: 12, buttonAttrs:{style:{background:props.data.isActive?'#ef5644':'#aaa'}} } },
            isSuperAdmin: { field: 'isSuperAdmin', label: '', type: 'checkbox', attrs:{style:{width:'100%',border:"none"}},text: 'سوپر ادمین', switchOptions: { size: 12, buttonAttrs:{style:{background:props.data.isSuperAdmin?'#ef5644':'#aaa'}} } },
            hasInsurance: { field: 'hasInsurance', label: '', type: 'checkbox', attrs:{style:{width:'100%',border:"none"}},text: 'بیمه دارد', switchOptions: { size: 12, buttonAttrs:{style:{background:props.data.hasInsurance?'#ef5644':'#aaa'}} } }
        }
    })
    useEffect(() => {
        props.setDisabled(!!form.disabled)
    }, [form.disabled])
    const rowCls = ''
    const node: I_formNode<I_model> = {
        className: 'gap-16-',
        v: [
            {
                v: [
                    {
                        className: rowCls,
                        h: [
                            { className: 'flex-1', input: 'type' },
                            { className: 'flex-1', input: 'name' },
                            { className: 'flex-1', input: 'nationalCode' },
                            { className: 'flex-1', input: 'mobile' },
                        ]
                    },
                    {
                        className: rowCls,
                        h: [
                            { className: 'flex-1', input: 'fatherName' },
                            { className: 'flex-1', input: 'email' },
                            { className: 'flex-1', input: 'birthDate' },
                            { className: 'flex-1', input: 'gender' }
                        ]
                    },
                    {
                        className: rowCls,
                        h: [
                            { className: 'flex-1', input: 'phone' },
                            { className: 'flex-1', input: 'essentialPhone' },
                            { className: 'flex-1', input: 'residentCity' },
                            { className: 'flex-1', input: 'hubId' }
                        ]
                    },
                    {
                        className: rowCls,
                        h: [
                            { className: 'flex-1', input: 'residentAddress' },
                            { className: 'flex-1', input: 'recommenderCode' },
                            { className: 'flex-1', html: '' },
                            { className: 'flex-1', html: '' }
                        ]
                    },
                    {
                        className: rowCls,
                        show:form.data.type?.id !== undefined && [2,4].indexOf(form.data.type.id) !== -1,
                        h: [
                            { className: 'flex-1', input: 'hasInsurance' },
                            { className: 'flex-1', input: 'isActive' },
                            { className: 'flex-1', input: 'isSuperAdmin' },
                            { className: 'flex-1', html: '' },
                            
                        ]
                    },

                ]
            }
        ]
    }
    return (
        <>
            {form.render.layout(node)}
            {
                form.errorsList.length > 0 &&
                <div className="fs-12- m-t-8- p-h-12- flex-row- align-v- gap-6-" style={{ color: 'red' }}>
                    <Icon path={mdiInformationOutline} size={0.8} color='red' />
                    {form.errorsList[0]}
                </div>
            }
        </>
    )
}
